var map = {
	"./arrow-down.svg": 3210,
	"./arrow-left.svg": 5409,
	"./arrow-right.svg": 2748,
	"./arrow-up.svg": 8345,
	"./check.svg": 2782,
	"./chevron-down.svg": 9404,
	"./chevron-up.svg": 1639,
	"./cooking-time.svg": 8908,
	"./copy.svg": 4317,
	"./difficulty-level.svg": 4028,
	"./facebook.svg": 1874,
	"./instagram.svg": 1446,
	"./linkedin.svg": 5272,
	"./mail.svg": 1515,
	"./menu-close.svg": 2924,
	"./menu.svg": 5775,
	"./minus-sign.svg": 232,
	"./phone.svg": 3790,
	"./play-filled.svg": 2977,
	"./play.svg": 3324,
	"./plus-sign.svg": 1616,
	"./rating.svg": 9417,
	"./search.svg": 7286,
	"./share.svg": 3907,
	"./star-empty.svg": 3818,
	"./star-full.svg": 3964,
	"./twitter.svg": 9887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;